module.exports = __webpack_public_path__ + "img/suitcase-medical.fd04a21f.svg";